import {Situation} from "../../../../../types/cardType";
import useStyle from "./targetAudience.css";
import Label from "../../../../../components/label/label";
import {getHrefForResults} from "../../../../../services/href";
import {changingPageToResults} from "../../../../../store/shared/sharedSlice";
import { useTheme } from 'react-jss';
import IDynamicThemeApp from "../../../../../types/dynamicThemeApp";
import cardAnalytics from "../../../../../services/gtag/cardEvents";

const TargetAudience = ({situations, cardId}: { situations: Situation[], cardId:string }) => {
    const targetAudienceTitle = window.strings.cardDetails.targetAudience;

    const theme = useTheme<IDynamicThemeApp>();
    const classes = useStyle({accessibilityActive: theme.accessibilityActive});
    if (situations.length < 1) return <></>
    return <div>
        <h3 className={classes.title}>{targetAudienceTitle}</h3>
        <div className={classes.linkList}>
            {situations.map((situation: Situation) => {
                const href = getHrefForResults({situationFilter: situation.id});
                const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    cardAnalytics.clickOnLabelEvent({cardId:cardId, labelId:situation.id, labelName:situation.name});
                    changingPageToResults({
                        value: {situation_id: situation.id, query: situation.name},
                        removeOldFilters: true
                    });
                }
                return <a href={href} key={situation.id} className={classes.link}
                          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => onClick(e)}>
                    <Label key={situation.id} situation={situation}/>
                </a>
            })}
        </div>
    </div>
}
export default TargetAudience;
